import { render, staticRenderFns } from "./AccrualStatus.vue?vue&type=template&id=b7470444&scoped=true"
import script from "./AccrualStatus.vue?vue&type=script&lang=js"
export * from "./AccrualStatus.vue?vue&type=script&lang=js"
import style0 from "./AccrualStatus.vue?vue&type=style&index=0&id=b7470444&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7470444",
  null
  
)

export default component.exports